import { render, staticRenderFns } from "./CompetencesLegend.vue?vue&type=template&id=734d3272&"
import script from "./CompetencesLegend.vue?vue&type=script&lang=js&"
export * from "./CompetencesLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports